import Icon from '../components/Icon'

Icon.register({
  'cloud-moon': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M342.8 352.7c40.9 3.5 73.2 37.4 73.2 79.3 0 44.2-35.8 80-80 80h-240c-53 0-96-43-96-96 0-41.9 27.1-77.2 64.6-90.3-0.1-1.9-0.6-3.7-0.6-5.7 0-53 43-96 96-96 36.2 0 67.4 20.3 83.7 49.9 11.5-11 27.1-17.9 44.3-17.9 35.3 0 64 28.7 64 64 0 12-3.5 23.1-9.2 32.7zM565.3 298.4c8.2-1.6 14 8 8.7 14.5-33.4 41.1-82.7 67-137.1 70.4-11.1-23.1-29.9-41.8-53.5-52.6 0.4-3.5 0.6-7.1 0.6-10.7 0-52.9-43.1-96-96-96-12.7 0-25 2.5-36.4 7.2-5.1-5.3-10.8-9.9-16.7-14.2-1.1-8.2-1.8-16.5-1.8-25 0-106.1 86-192 191.9-192 11.7 0 23.4 1.1 35.1 3.2 8.2 1.6 10.1 12.6 2.8 16.7-47.1 26.8-76.1 76.6-76.1 130.8 0 94 85.4 165.4 178.5 147.7z'
      }
    ]
  }
})
